export default function WelcomeMessage() {
  return (
    <>
      <p>Hello There!</p>
      <br />
      <p>
        I'm Brandon, your alpaca loving developer. Have you met my pal Hercules
        above? Well, Herc and I were talking the other day, and we got to
        thinking that what this world needed was a convenient, and more
        importantly, <span className='font-bold'>FREE</span>, way to keep track
        of of him and all of the other alpacas in his herd. So, being the
        resourceful folk that we are, I now present to you (drumroll 🥁 please)
        the <span className='font-bold'>Alpaca Tracker</span>.
      </p>
      <br />
      <p>
        But, Herc and I are never satisfied. We always want bigger, better, and
        badder (Well, not too bad we try not to get the law involved 😄). This
        is where you come in. Make an account, login, muck around a bit. Don't
        be afraid to kick the tires! If you see some place that needs a little
        grease, or little polish, or heaven forbid is working about as well as a
        screen door on a submarine, please don't keep it to yourself!
      </p>
      <br />
      <p>
        <span className='font-bold'>Scream it from the rooftops!</span>
      </p>
      <br />
      <p>
        {' '}
        Well, I guess that won't work unless you live nearby. In that case, just
        send an email to admin@alpacatracker.com. Herc will read them all and
        pass the message on to me.
      </p>
      <br />
      <p>Thank You!</p>
      <br />
      <p className="font-['Homemade_Apple']">Brandon & Hercules</p>
    </>
  );
}
